import React from 'react';
// Hooks
import { useGetCurrUser } from 'hooks';
// Helpers
import { getEnvLink } from 'helpers/routes';
// UI3
import Button from 'ui3/Button/Button';
// Styles
import styles from './GetStartedCtaBanner.module.scss';

interface GetStartedCtaBannerProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const GetStartedCtaBanner = ({
  title = "Be Part of the World's Biggest Sports Community",
  description = 'Build deeper connections with creators, explore fan communities, and\ncollaborate with top brands in a space designed to bring everyone closer.',
  buttonText = 'Get Started Now',
  onButtonClick,
}: GetStartedCtaBannerProps) => {
  const backgroundUrl = `${getEnvLink()}/images/home-page/bento-box/bg.png`;
  const { data } = useGetCurrUser();
  const isLoggedIn = !!data?.me?.id;

  return (
    <div className={styles.parentContainer}>
      <div
        className={styles.wrapper}
        style={{
          backgroundImage: `url(${backgroundUrl})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className={styles.bannerContainer}>
          <div className={styles.content}>
            <h2 className={styles.title}>{title}</h2>
            <p className={styles.description}>{description}</p>
          </div>
          {isLoggedIn ? (
            <Button onClick={onButtonClick} className={styles.button}>
              {buttonText}
            </Button>
          ) : (
            <Button onClick={onButtonClick} className={styles.button}>
              {buttonText}
            </Button>
          )}

          <div className={styles.collageWrapper}>
            <img
              src={`${getEnvLink()}/images/home-page/bento-box/bentoMain.png`}
              alt="Creators and fans collage"
              className={styles.collageImage}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetStartedCtaBanner;
